import React from 'react';
import Select, {  Props as SelectProps} from 'react-select';
import { sortByNameString } from '../../../services/common';

interface CustomSelectProps extends SelectProps<CustomSelectOption> {
  isSort?: boolean,
  label: string,
}

export interface CustomSelectOption {
  value: string;
  name: string;
}

const CustomSelect: React.FC<CustomSelectProps> = ({ isSort, label, options, ...rest }) => {
    let sortOptions = [];
    if (isSort && Array.isArray(options)) {
        sortOptions = options.sort((a, b) => sortByNameString(a.name, b.name))
    }
    return (<><label>{label}</label>
        <Select options={sortOptions} {...rest} />
    </>)
}
export default CustomSelect